import ApplyConversationActionResponseMessage from 'owa-service/lib/contract/ApplyConversationActionResponseMessage';
import { TableView } from 'owa-mail-list-store';
import onTriageActionCompleted from './onTriageActionCompleted';
import onTriageActionFailed from './onTriageActionFailed';
import handleServerResponseSuccessAndError from './handleServerResponseSuccessAndError';

/**
 * Processes the applyConversationActionResponse message
 * Regardless of success or failure we shall remove the rows from tombstone
 * Upon failure we should reload the table to be in a consistent state with the server
 * @param applyConversationActionPromise promise to process
 * @param rowKeys rowKeys on which the action was taken
 * @param sourceFolderId folder id to which the rows belonged
 * @param tableView table view to which the rows belonged
 * @param shouldRemoveRowsFromTombstone flag indicating whether to remove the rows from tombstone map after the response from server is received
 */
export default function processApplyConversationActionResponseMessage(
    applyConversationActionPromise: Promise<ApplyConversationActionResponseMessage>,
    rowKeys: string[],
    sourceFolderId: string,
    tableView: TableView,
    shouldRemoveRowsFromTombstone: boolean
): Promise<void> {
    return applyConversationActionPromise
        .then(response => {
            onTriageActionCompleted(rowKeys, sourceFolderId, shouldRemoveRowsFromTombstone);
            return handleServerResponseSuccessAndError(response);
        })
        .catch(error => {
            onTriageActionCompleted(rowKeys, sourceFolderId, shouldRemoveRowsFromTombstone);
            onTriageActionFailed(tableView);
            return Promise.reject(error);
        });
}
